<template>
  <div
    class="clearfix moduleTitle-container"
    :class="typeTitle === 'inside' ? 'inside' : ''"
  >
    <div v-if="title" class="moduleTitle-name left">
      <span v-if="icon" :class="icon" class="icon" />
      {{ title }}
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ModuleTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ''
    },
    typeTitle: {
      type: String,
      default: ''
    }
  }
};
</script>
<style scoped lang="scss">
.moduleTitle-container {
  padding: 40px 0px 30px 0px;
  line-height: 30px;
  .moduleTitle-name {
    color: #333;
    font-weight: bold;
    font-size: 26px;
    margin-right: 20px;
    display: flex;
    align-items: center;
  }
  .classify {
    color: #666;
    span {
      padding: 0 5px;
    }
    & a:hover {
      color: #007afc;
    }
  }
  .icon {
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    float: left;
    margin-right: 14px;
    background-position: right;
  }
  .icon1 {
    background-image: url('~@/assets/img/icon1H.png');
  }
  .icon2 {
    background-image: url('~@/assets/img/icon2H.png');
  }
  .icon3 {
    background-image: url('~@/assets/img/icon3H.png');
  }
  .icon4 {
    background-image: url('~@/assets/img/icon4H.png');
  }
  .icon5 {
    background-image: url('~@/assets/img/icon5H.png');
  }
  .icon6 {
    background-image: url('~@/assets/img/icon6H.png');
  }
  .icon7 {
    background-image: url('~@/assets/img/icon7H.png');
  }
  .icon8 {
    background-image: url('~@/assets/img/icon8H.png');
  }
  .icon9 {
    background-image: url('~@/assets/img/icon9H.png');
  }
}
.inside {
  padding: 20px 40px;
  padding-bottom: 5px;
  border-bottom: 0;
  .moduleTitle-name {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
}
</style>
